const slick = require('slick-carousel');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PubSub from 'underpub-js';
import Equalizer from "../../../../scripts/classes/Equalizer";

var FeaturedEventsSlider = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

FeaturedEventsSlider.prototype.init = function () {

	let self = this;
	
	self.$eventsSlider = self.options.$el.find(`.slider`);

	self.$eventsSlider.slick({
		// speed: 350,
		slidesToShow: 3,
		// infinite: true,
		arrows: false,
		// dots: false,
		// fade: true,
		// autoplay: true,
		// autoplaySpeed: 8000,

		responsive: [
			// {
			//   breakpoint: 1024,
			//   settings: {
			// 	slidesToShow: 3,
			// 	slidesToScroll: 3,
			// 	infinite: true,
			// 	dots: true
			//   }
			// },
			{
			  breakpoint: 1000,
			  settings: {
				slidesToShow: 2
			  }
			},
			{
				breakpoint: 768,
				settings: {
				  slidesToShow: 1
				}
			}
		]
	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideEq = new Equalizer( self.options.$el.find(`.slide .content`) );
	this.slideEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideEq = new Equalizer( self.options.$el.find(`.slide .content`) );
		self.slideEq.equalizeHeights();
	});

	self.options.$el.find(`.dots-nav .dot`).on('click', function() {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		$(this).addClass('active');

		var slideNumber = $(this).data('slideNumber');

		self.$eventsSlider.slick('slickGoTo', slideNumber - 1);

	});

	this.$eventsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		self.options.$el.find(`[data-slide-number="${nextSlide+1}"]`).addClass('active');

	});
	

};

export default FeaturedEventsSlider;
